import axios from 'axios';

const rawBackendUrl = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');
const BACKEND_URL = rawBackendUrl.replace(/\/api$/, '');
const API = `${BACKEND_URL}/api`;

function authHeaders(token) {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function activatePlatformWorkflow(token, workflowId) {
  return axios.post(
    `${API}/platform/system-automations/workflows/${workflowId}/activate`,
    {},
    { headers: authHeaders(token) },
  );
}

export async function pausePlatformWorkflow(token, workflowId) {
  return axios.post(
    `${API}/platform/system-automations/workflows/${workflowId}/pause`,
    {},
    { headers: authHeaders(token) },
  );
}

export async function duplicatePlatformWorkflow(token, workflowId) {
  return axios.post(
    `${API}/platform/system-automations/workflows/${workflowId}/duplicate`,
    {},
    { headers: authHeaders(token) },
  );
}

export async function archivePlatformWorkflow(token, workflowId) {
  return axios.put(
    `${API}/platform/system-automations/workflows/${workflowId}`,
    { status: 'archived' },
    { headers: authHeaders(token) },
  );
}

export async function movePlatformWorkflow(token, workflowId, { category, folderId } = {}) {
  const payload = {};
  if (category) payload.category = category;
  if (folderId !== undefined) payload.folder_id = folderId;
  return axios.put(
    `${API}/platform/system-automations/workflows/${workflowId}`,
    payload,
    { headers: authHeaders(token) },
  );
}

export async function deletePlatformWorkflow(token, workflowId) {
  return axios.delete(
    `${API}/platform/system-automations/workflows/${workflowId}`,
    { headers: authHeaders(token) },
  );
}

export async function fetchPlatformWorkflowFolders(token) {
  const res = await axios.get(`${API}/platform/automations/folders`, {
    headers: authHeaders(token),
  });
  const folders = res.data?.folders;
  return Array.isArray(folders) ? folders : [];
}

export async function createPlatformWorkflowFolder(token, payload) {
  return axios.post(`${API}/platform/automations/folders`, payload, {
    headers: authHeaders(token),
  });
}

export async function updatePlatformWorkflowFolder(token, folderId, payload) {
  return axios.put(`${API}/platform/automations/folders/${folderId}`, payload, {
    headers: authHeaders(token),
  });
}

export async function deletePlatformWorkflowFolder(token, folderId) {
  return axios.delete(`${API}/platform/automations/folders/${folderId}`, {
    headers: authHeaders(token),
  });
}

export function getPlatformBuilderTestPath(workflowId) {
  return `/platform/automations/workflows/${workflowId}/builder?panel=test`;
}

export async function toggleAgencyAutomation(token, agencyId, workflowId, body = {}) {
  return axios.post(
    `${API}/automations/agency/${agencyId}/${workflowId}/toggle`,
    body,
    { headers: authHeaders(token) },
  );
}

export async function duplicateAgencyAutomation(token, workflowId, agencyId) {
  return axios.post(
    `${API}/automations/duplicate/${workflowId}?agency_id=${agencyId}`,
    {},
    { headers: authHeaders(token) },
  );
}

export async function deleteAgencyAutomation(token, agencyId, workflowId) {
  return axios.delete(
    `${API}/automations/agency/${agencyId}/${workflowId}`,
    { headers: authHeaders(token) },
  );
}

export function getPlatformBuilderPath(workflowId) {
  return `/platform/automations/workflows/${workflowId}/builder`;
}

export function getAgencyBuilderPath(agencyId, workflowId, query = '') {
  return `/agency/${agencyId}/automations/builder/${workflowId}${query}`;
}
